import { nodeRestApi } from '@/plugins/api';

export default {
  // Fetches list of ecofrost devices with pagination
  async fetchEcofrostList(
    { commit },
    { page = 1, limit = 10, search = '' } = {}
  ) {
    commit('setError', false, { root: true });
    commit('setEcofrostLoading', true);
    try {
      const params = { page, limit };

      if (search && search.trim() !== '') {
        params.search = search;
      }

      const response = await nodeRestApi.get('ecofrost/list/paginated', {
        params
      });

      if (response.data.success) {
        const ecofrostList = response.data.data.map(device => {
          return {
            deviceType: 'ecofrost',
            ...device,
            topic: device.Topic || device.topic
          };
        });
        commit('setEcofrostList', ecofrostList);
        commit('setEcofrostPagination', response.data.pagination);
        return ecofrostList;
      }

      return [];
    } catch (error) {
      if (error.isAxiosError) {
        if (error.response) {
          commit('setError', error.response.data.error.message, { root: true });
        }
      } else {
        commit('setError', error, { root: true });
      }
    } finally {
      commit('setEcofrostLoading', false);
    }
  },

  async fetchEcofrostPage(
    { commit },
    { page = 1, limit = 10, search = '' } = {}
  ) {
    try {
      const params = {
        page,
        limit
      };

      if (search && search.trim() !== '') {
        params.search = search;
      }

      const response = await nodeRestApi.get('ecofrost/list/paginated', {
        params
      });

      if (response.data.success) {
        return response.data.data.map(device => ({
          deviceType: 'ecofrost',
          ...device,
          topic: device.Topic || device.topic
        }));
      }

      return [];
    } catch (error) {
      return [];
    }
  },

  // Fetches current measurements of ecofrost device
  async fetchEcofrostCurrent({ commit }, topic) {
    commit('setError', false, { root: true });
    try {
      const response = await nodeRestApi.get(`ecofrost/${topic}`);
      const ecofrostCurrent = response.data;
      commit('setEcofrostCurrent', ecofrostCurrent);
    } catch (error) {
      if (error.isAxiosError) {
        if (error.response) {
          commit('setError', error.response.data.error.message, { root: true });
        }
      } else {
        commit('setError', error, { root: true });
      }
    }
  }
};
